<template>
  <div class="norm_form">
     <div class="form-npa private-pg">
      <div class="position">
        <div class="bg-white">
          <v-form
            action
            @submit.prevent="createLawNorm"
          >
          <div class="form-col-2">
            <!------->
            <div
              class="form-group"
            >
                <label>
                  {{ $t("Статья") }}
                  <span class="asterix">*</span>
                  <fieldInfo />
                </label>
                <v-select
                      id="developer"
                      item-value="transName"
                      item-text="transName"
                      v-model="form.norm.params.article_value"
                      :items="options.refArticle"
                      input="transName"
                      outlined
                      rounded
                      dense
                ></v-select>
              </div>
              <!------>

              <div v-if="form.norm.params.article_value == 'Статья'">
                <LawNormFormArticle
                  v-if="law.articles && law.articles.length > 0"
                  :articles="law.articles"
                  @change="changeArticle"
                  @cancel="cancelArticle"
                  :select-article="form.norm.params.article_id"
                />
                <div class="form-group mb-8">
                  <label>

                  </label>
                  <button
                    type="button"
                    class="btn btn-default"
                    @click="() => {cancelArticle();showArticleFields = true;}"
                  >
                    + <span>Добавить статью</span>
                  </button>
                </div>
                <!------->
                <div v-if="showArticleFields" class="form-group">
                    <label>
                      {{ $t("Номер статьи") }}
                      <span class="asterix">*</span>
                      <fieldInfo />
                    </label>
                    <v-text-field
                      v-model="form.article.article_number"
                      type="number"
                      required
                      outlined
                      rounded
                      dense
                      clearable
                    />
                  </div>
                <div class="form-group">
                  <label>
                    {{ $t("Номер части") }}
                    <fieldInfo />
                  </label>
                  <v-text-field
                    v-model="form.norm.article_part"
                    type="text"
                    outlined
                    rounded
                    dense
                    clearable
                  />
                </div>
                </div>
                <!------->
                <div
                  class="form-group"
                >
                  <label>
                    {{ $t("Текст нормы на гос.языке") }}
                    <span class="asterix"></span>
                    <fieldInfo />
                  </label>
                  <v-textarea
                    v-model="form.norm.normTextKg"
                    rows="3"
                    required
                    outlined
                  />
                </div>
                <!------->
                <div
                 :class="{ invalid: $v.form.norm.normText.$error }"
                  class="form-group"
                >
                  <label>
                    {{ $t("Текст нормы на оф.языке") }}
                    <span class="asterix">*</span>
                    <fieldInfo />
                  </label>
                  <v-textarea
                    v-model="form.norm.normText"
                    rows="3"
                    required
                    outlined
                  />
                </div>
                <div
                  class="form-group"
                >
                  <label>
                    {{ $t("Требует внесения изменений в закон") }}
                    <fieldInfo />
                  </label>
                  <v-checkbox
                    v-model="form.norm.law_changes_required"
                  />
                </div>
                <div
                  v-show="form.norm.law_changes_required"
                  class="form-group"
                >
                  <label>
                    {{ $t("Цельный закон") }}
                    <fieldInfo />
                  </label>
                  <button
                    type="button"
                    class="btn btn-default"
                    @click="() => {showLawToChangeModal = true; items = []}"
                  >
                    <span>Найти</span>
                  </button>
                  <div class="font-weight-medium ml-2" v-if="lawToChange">
                   №{{lawToChange.number}} {{lawToChange.transName}} {{lawToChange.name}}
                    <button type="button" @click="removeLawToChange"><i class="fa fa-trash" aria-hidden="true"></i></button>
                  </div>
                  <v-dialog v-model="showLawToChangeModal" max-width="560">
                    <v-card class="modal">
                      <div class="modal-head">
                        {{ $t('Выберите закон, требующий изменения') }}
                        <v-btn color="modal-close" @click.native="showLawToChangeModal = false">
                          <span class="pro-icon-close1"></span>
                        </v-btn>
                      </div>
                      <div
                        class="modal-body"
                      >
                        <div class="form-group">
                          <h5>{{ $t( "Закон") }}</h5>
                          <v-autocomplete
                            v-model="form.norm.law_to_change_id"
                            :loading="loading"
                            :items="items"
                            :search-input.sync="search"
                            item-text="name"
                            item-value="id"
                            required
                            outlined
                            dense
                            clearable
                            :placeholder="$t('Введите название для поиска')"
                            @change="onLawChange"
                          />
                        </div>
                        </div>
                    </v-card>
                  </v-dialog>
                </div>
                <!------->
                <div
                  :class="{ invalid: $v.form.norm.params.developers.$error }"
                  class="form-group"
                >
                    <label>
                      {{ $t("Ответственный гос.орган") }}
                      <span class="asterix">*</span>
                      <fieldInfo />
                    </label>
                    <div class="developer-block">
                      <div
                        class="developer-add"
                        @click="addNewDeveloper"
                      >
                        +
                      </div>

                      <DeveloperList
                        :developers="options.refDeveloper"
                        :list="form.norm.params.developers"
                        @change-developer="changeDeveloper"
                        @change-is-main="changeIsMain"
                        @remove-developer="removeDeveloper"
                      />
                    </div>
                  </div>
                  <!------->
                  <div
                    class="form-group"
                  >
                    <label>
                      {{ $t("Срок реализации") }}
                      <span class="asterix"></span>
                      <fieldInfo />
                    </label>
                    <div class="form-date">
                      <v-menu
                        v-model="formImpDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            v-model="form.norm.implementationPeriod"
                            required
                            readonly
                            v-on="on"
                            outlined
                            rounded
                            dense
                          />
                        </template>
                        <v-date-picker
                          v-model="form.norm.implementationPeriod"
                          @input="formImpDateMenu = false"
                          :weekday-format="getDay"
                          :month-format="getMonthFormat"
                          :header-date-format="getHeaderDateFormat"
                          no-title
                          first-day-of-week="1"
                        />
                      </v-menu>
                    </div>
                    <div
                      class="clear-date"
                      @click="form.norm.implementationPeriod = ''"
                    >
                      Очистить
                    </div>
                    <ImplementationPeriodCalculator
                      :law="law"
                      @save="saveImplementationPeriod"
                    />
                  </div>
                  <!------->
                  <div
                    class="form-group"
                  >
                      <label>
                        {{ $t("Исполнение нормы") }}
                        <fieldInfo />
                      </label>
                      <v-select
                            selected="''"
                            id="developer"
                            item-value="id"
                            item-text="transName"
                            v-model="form.norm.executionNorm"
                            :items="options.executionNorm"
                            input="transName"
                            outlined
                            rounded
                            dense
                      ></v-select>
                    </div>
                    <!------->
                    <div class="article_act" v-if="form.norm && form.norm.executionNorm === 1">
                      <div
                        class="article_act-button"
                        v-if="!isAddLegalAct"
                        @click="changeAddLegalAct(true)"
                      >
                          {{ $t("Добавить новый") }}
                      </div>
                      <div
                        class="article_act-button"
                        @click="changeAddLegalAct(false)"
                        v-else
                      >
                          {{ $t("Отмена") }}
                      </div>
                      <label class="article_act-label">
                          {{ $t("или выбрать") }}
                      </label>
                      <LawNormFormByLaws
                        v-if="Object.keys(law).length > 0 && law.byLaws"
                        :by-laws="law.byLaws"
                        @change="changeByLaw"
                        @remove="removeByLaw"
                        @clear="clear"
                        :select-by-laws="form.norm.params.by_law_id"
                      />
                    </div>

                    <!--Под законный акт-->
                    <div
                      v-if="isAddLegalAct"
                      class="legal_act"
                    >
                      <div class="act_add-form">
                        <div
                          class="form-group"
                        >
                            <label>
                              {{ $t("Вид подзаконного акта") }}
                              <span class="asterix">*</span>
                              <fieldInfo />
                            </label>
                            <v-select
                                  id="developer"
                                  item-value="id"
                                  item-text="transName"
                                  v-model="legalAct.kindByLaw"
                                  :items="options.kindByLaw"
                                  input="transName"
                                  outlined
                                  rounded
                                  dense
                            ></v-select>
                        </div>
                        <!----->
                        <div
                          class="form-group"
                        >
                          <label>
                            {{ $t("Наименование на гос.языке") }}
                            <span class="asterix"></span>
                            <fieldInfo />
                          </label>
                          <v-textarea
                            v-model="legalAct.nameKg"
                            rows="3"
                            required
                            outlined
                          />
                        </div>
                        <!------->
                        <div
                          class="form-group"
                        >
                          <label>
                            {{ $t("Наименование на оф.языке") }}
                            <span class="asterix">*</span>
                            <fieldInfo />
                          </label>
                          <v-textarea
                            v-model="legalAct.name"
                            rows="3"
                            required
                            outlined
                          />
                        </div>
                        <!------->
                        <div
                            class="form-group"
                        >
                          <label>
                            {{ $t("Номер") }}
                            <span class="asterix">*</span>
                            <fieldInfo />
                          </label>
                          <v-text-field
                            v-model="legalAct.number"
                            required
                            outlined
                            rounded
                            dense
                            clearable
                          />
                        </div>
                        <!------>
                        <div
                          class="form-group"
                        >
                          <label>
                            {{ $t("Дата принятия") }}
                            <span class="asterix">*</span>
                            <fieldInfo />
                          </label>
                          <div class="form-date">
                            <v-menu
                              v-model="legalActAdoptionDateMenu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px"
                            >
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="legalAct.adoptionDate"
                                  required
                                  readonly
                                  v-on="on"
                                  outlined
                                  rounded
                                  dense
                                />
                              </template>
                              <v-date-picker
                                v-model="legalAct.adoptionDate"
                                @input="legalActAdoptionDateMenu = false"
                                :weekday-format="getDay"
                                :month-format="getMonthFormat"
                                :header-date-format="getHeaderDateFormat"
                                no-title
                                first-day-of-week="1"
                              />
                            </v-menu>
                          </div>
                        </div>
                        <!------>
                        <div
                          class="form-group-cbd"
                        >
                          <div
                              class="form-group"
                          >
                            <label>
                              {{ $t("Код документа в ЦБД") }}
                              <span class="asterix"></span>
                              <fieldInfo />
                            </label>
                            <v-text-field
                              v-model="legalAct.zbdCode"
                              outlined
                              rounded
                              dense
                              clearable
                            />
                          </div>
                          <div
                            class="fill_cbd-code"
                            :class="{'fill_cbd-code-disabled' : legalAct.zbdCode.length == 0 }"
                            @click="fillCodeCBD"
                          >
                            Заполнить по коду ЦБД
                          </div>
                        </div>
                      </div>
                    </div>
                    <!------->
                  <div
                    class="form-error"
                    v-if="error.status"
                  >
                    {{ error.message }}
                  </div>
                  <div class="form-bottom">
                    <div class="form-group form-action">
                      <button
                        class="btn btn-default blue"
                        type="submit"
                      >
                        {{ $t("Сохранить") }}
                      </button>
                      <div
                        class="btn btn-default white"
                        @click="cancel"
                      >
                        {{ $t("Отмена") }}
                      </div>
                    </div>
                  </div>
            </div>
          </v-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import mixin from '@/plugins/mixin/mixin'
import LAW from '@/model/law'

/* import components */
import LawNormFormArticle from '@/components/law/LawNormFormArticle';
import LawNormFormByLaws from '@/components/law/LawNormFormByLaws';
import { required } from 'vuelidate/lib/validators'
import fieldInfo from '@/components/app/fieldInfo'
import ImplementationPeriodCalculator from '@/components/widget/ImplementationPeriodCalculator.vue'
import DeveloperList  from '@/components/widget/DeveloperList.vue'
import Law from '@/model/law'

export default {
  name: 'LawNormForm',
  provide () {
    return {
      kindByLaw: this.options.kindByLaw
    }
  },
  mixins: [mixin],
  components: {
    LawNormFormArticle,
    fieldInfo,
    LawNormFormByLaws,
    ImplementationPeriodCalculator,
    DeveloperList
  },
  props: {
    error: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      required: true
    },
    law: {
      type: [Object, Array],
      default: required
    },
    page: {
      type: String,
      default: 'create'
    },
    editForm: {
      type: Object,
      default: () => { return {} }
    },
    lawToChange: {
      type: [Object, Array],
      required: false
    }
  },
  mounted() {
    this.options.executionNorm.push({id: '', transName: '', number_position: ''})
  },
  data: () => ({
      form: {
        norm: {
          params: {
            law_id: null,
            article_value: '',
            by_law_id: [],
            article_id: null,
            developers: [],
          },
          implementationPeriod: '',
          normText: '',
          normTextKg: '',
          executionNorm: '',
          article_part: '',
          law_changes_required: false,
          law_to_change_id: null,
        },
        article: {
          law_id: null,
          article_id: null,
          article_number: ''
        }
      },
      legalAct: {
          kindByLaw: '',
          name: '',
          nameKg: '',
          number: '',
          adoptionDate: '',
          zbdCode: '',
          law_id: null,
      },
      rules: {
        form: {
          norm: {
            normText: { required },
            params: {
              developers: { required },
            }
          }
        },
      },

      selectedExistingArticle: false,
      isAddLegalAct: false,
      selectedExistingByLaw: false,
      formImpDateMenu: false,
      legalActAdoptionDateMenu: false,
      showArticleFields: false,
      showLawToChangeModal: false,
      loading: false,
      items: [],
      search: ''
    }),

    watch: {
      search(val) {
        if (val && val !== this.form.norm.law_to_change_id) {
          this.querySelections(val);
        }
      }
    },

    validations () {
      return this.rules
    },

    created() {
      if (this.page == 'edit') {
        this.form = this.editForm
        this.selectedExistingArticle = true
        this.$forceUpdate()
      }
    },

    methods: {
      changeIsMain (index) {
        this.form.norm.params.developers.forEach((item) => {
          item.is_main = false
          item.isMain = false
        })

        this.form.norm.params.developers[index].is_main = true
        this.form.norm.params.developers[index].isMain = true
      },

      changeDeveloper (index, id) {
        this.form.norm.params.developers[index].id = id
      },

      addNewDeveloper () {
        let newDeveloper = {
          id: 0,
          is_main: false
        }

        if (this.form.norm.params.developers.length == 0) {
          newDeveloper.is_main = true
        }

        this.form.norm.params.developers.push(newDeveloper)
      },

      removeDeveloper(index) {
        this.form.norm.params.developers.splice(index, 1);
      },

      saveImplementationPeriod (value) {
        this.form.norm.implementationPeriod = value
      },

      fillCodeCBD () {
        LAW.getDocumentByCode(this.legalAct.zbdCode).then((response) => {
          let legalAct = {
            name: response.data.Name.Rus,
            nameKg: response.data.Name.Kyr,
            number: response.data.Number,
            adoptionDate: response.data.DateAdopted,
          }

          this.legalAct = { ...this.legalAct, ...legalAct }
        }).catch(() => {

        })
      },
      clear () {
        this.form.norm.params.by_law_id = []
        this.selectedExistingByLaw = false
      },

      cancel () {
        this.$router.push({
          name: 'law-view',
          params: {
            id: this.law.id
          }
        })
      },

      removeByLaw (id) {
        this.law.byLaws = this.law.byLaws.filter(item => item.id != id)
        this.$forceUpdate()
      },

      changeAddLegalAct (value) {
        this.isAddLegalAct = value
      },

      changeByLaw(byLaw) {
        if (this.form.norm.params.by_law_id.includes(byLaw.id)) {
          this.form.norm.params.by_law_id = this.form.norm.params.by_law_id.filter(item => item != byLaw.id)
        } else {
          this.form.norm.params.by_law_id.push(byLaw.id)
        }

        this.selectedExistingByLaw = true
      },

      changeArticle (article) {
        this.form.article.article_id = article.id
        this.form.norm.params.article_id = article.id
        this.form.article.article_number = article.number
        this.selectedExistingArticle = true
      },

      cancelArticle () {
        this.form.article.article_id = null
        this.form.norm.params.article_id = null
        this.form.article.article_number = ''
        this.selectedExistingArticle = false
      },

      validateForm () {
          this.$v.$touch()
          if (this.$v.$invalid) {
            this.$nextTick(() => {
              this.scrollToFirstError()
            })

            return false
          }

          return true
      },
      createLawNorm() {
        if (!this.validateForm()) {
          return
        }

        this.form.norm.params.law_id = this.law.id;
        this.form.article.law_id = this.law.id;
        this.legalAct.law_id = this.law.id;

        this.$emit('create', {
          form: this.form,
          legalAct: this.legalAct,
          selectedExistingArticle: this.selectedExistingArticle,
          isAddLegalAct: this.isAddLegalAct,
          selectedExistingByLaw: this.selectedExistingByLaw
        })
      },

       // Прокручивание до поля с ошибкой
      scrollToFirstError () {
        const element = document.querySelector('.invalid')

        if (element) {
          const domRect = element.getBoundingClientRect()
          window.scrollTo(
            domRect.left +
            (document.body.scrollLeft || document.documentElement.scrollLeft),
            domRect.top +
            (document.body.scrollTop || document.documentElement.scrollTop) -
            90
          )
        }
      },
      querySelections(val) {
        if (val.length >= 1) {
          this.searchLaw(val);
        }
      },

      searchLaw(search) {
        this.setLoading(true);

        Law.searchLawToChange(search)
          .then((response) => {
            this.items = response.items;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.setLoading(false);
          });
      },

      setLoading(loading) {
        this.loading = loading;
      },

      onLawChange(val) {
        const newLaw = this.items.find(item => item.id === val);
        this.$emit('update:lawToChange', newLaw);
        this.showLawToChangeModal = false;
      },
      removeLawToChange() {
        this.form.norm.law_changes_required = false
        this.$props.lawToChange = null;
        this.form.norm.law_to_change_id = null;
      }
    }
}

</script>
<style lang="scss" scoped>

.developer {
  &-block {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  &-add {
    width: 35px;
    height: 35px;
    border: 1px solid #575555;
    border-radius: 100px;
    font-weight: 600;
    font-size: 24px;
    color: #575555;
    line-height: 30px;
    text-align: center;
    cursor: pointer;
  }
}

.form-error {
    padding: 20px 20px;
    background-color: rgba(206,37,43, 0.5);
    color: #534a4b;
    border-radius: 10px;
    font-size: 18px;
    margin: 20px 0px;
    font-weight: 600;
  }
  .form-bottom .form-group.form-action {
    justify-content: center;
    .white {
        cursor: pointer;
      }

  }
  .article_act {
    margin-top: 50px;

    &-label {
      width: 150px;
    }

    &-button {
      margin-right: 40px;
      height: 40px;
      min-width: 160px;
      background-color: #004484;
      padding: 5px 15px;
      color: #fff;
      cursor:pointer;
      display: inline-block;
      margin-bottom: 40px;

      &-active {
        pointer-events: none;
        background-color: gray;
      }
    }
  }

  .legal_act {
      transition: all 0.7s ease 0s;
      text-align: left;
      margin-bottom: 20px;

      &-active {
        display: block;
        max-height: 2000px;
      }

      .form-group-cbd {
        display: flex;
        flex-direction: column;

        .fill_cbd-code {
          background-color: #03305c;
          color: #fff;
          padding: 7px 20px;
          display: block;
          -webkit-box-align: center;
          -ms-flex-align: center;
          align-items: center;
          cursor: pointer;
          max-width: 250px;
          text-align: center;
          margin-left: auto;

          &-disabled {
            background-color: #757575 !important;
            color: #fff;
            cursor: default;
            pointer-events: none;
          }
        }

      }
  }

  .clear-date {
    margin-left: 10px;
    cursor: pointer;
  }
</style>
